import { memo } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import styled from 'styled-components';
import { VStack, Box } from '@cbhq/cds-web/layout';
import { Pressable } from '@cbhq/cds-web/system';
import { TextHeadline } from '@cbhq/cds-web/typography';
import ChevronRight from '../../../assets/icons/ChevronRight.js';
import LanguageCountrySelector from './LanguageCountrySelector.js';
import { jsxs, jsx } from 'react/jsx-runtime';
const i18nKey = 'MobileLanguageCountrySelector';
const messages = defineMessages({
  title: {
    id: `${i18nKey}.title`,
    defaultMessage: 'Language',
    description: `
    #Component: LEGACY
    #CharLimit: 40
    #Context: Title for mobile language country selector (CharLimit autocalculated to 40)`
  }
});
function MobileLanguageCountrySelector({
  localeInformation,
  closeLanguageSelector
}) {
  const _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  return /*#__PURE__*/jsxs(VStack, {
    spacingHorizontal: 3,
    width: "100%",
    height: "100%",
    children: [/*#__PURE__*/jsx(Box, {
      spacingTop: 2,
      width: "100%",
      flexDirection: "row",
      justifyContent: "center",
      position: "relative",
      children: /*#__PURE__*/jsxs(Box, {
        flexDirection: "column",
        justifyContent: "center",
        position: "relative",
        width: "100%",
        children: [/*#__PURE__*/jsx(Box, {
          position: "absolute",
          left: 0,
          justifyContent: "center",
          onClick: closeLanguageSelector,
          children: /*#__PURE__*/jsx(Pressable, {
            background: "transparent",
            children: /*#__PURE__*/jsx(ChevronLeft, {})
          })
        }), /*#__PURE__*/jsx(Box, {
          alignSelf: "center",
          children: /*#__PURE__*/jsx(TextHeadline, {
            as: "p",
            children: formatMessage(messages.title)
          })
        })]
      })
    }), /*#__PURE__*/jsx(LanguageCountrySelector, {
      localeInformation: localeInformation
    })]
  });
}
const ChevronLeft = styled(ChevronRight)`
  transform: rotate(180deg);
`;
const MobileLanguageCountrySelector$1 = /*#__PURE__*/memo(MobileLanguageCountrySelector);
export { MobileLanguageCountrySelector$1 as default };
//# sourceMappingURL=MobileLanguageCountrySelector.js.map
